import { useAuthStateStore } from '../../store/useAuthStateStore';
export const useUserUUID = (publicIfNull = false) => {
    const uuid = useAuthStateStore((state) => state.uuid);
    if (uuid === undefined) {
        if (publicIfNull === false) {
            return undefined;
        }
        else {
            return 'public';
        }
    }
    else {
        return uuid;
    }
};
//# sourceMappingURL=useUserUUID.js.map